import { useEffect, useState } from "react";

export const DROP_DATE = new Date("2026-10-26T00:00:00-07:00");

const pad = (n) => String(n).padStart(2, "0");

export const Countdown = ({ dark = true, compact = false }) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const diff = Math.max(0, DROP_DATE.getTime() - now);
  const cells = [
    ["Days", Math.floor(diff / 86400000)],
    ["Hours", Math.floor(diff / 3600000) % 24],
    ["Min", Math.floor(diff / 60000) % 60],
    ["Sec", Math.floor(diff / 1000) % 60],
  ];

  if (compact) {
    return (
      <div data-testid="drop-countdown" className="flex gap-6 md:gap-10">
        {cells.map(([label, value]) => (
          <div key={label} data-testid={`countdown-${label.toLowerCase()}`} className="text-center">
            <p className="font-serif text-2xl md:text-4xl leading-none tabular-nums">{pad(value)}</p>
            <p className={`text-[8px] tracking-[0.3em] uppercase mt-2 ${dark ? "text-white/40" : "text-black/40"}`}>
              {label}
            </p>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div data-testid="drop-countdown" className="flex gap-8 md:gap-14 mb-14">
      {cells.map(([label, value]) => (
        <div key={label} data-testid={`countdown-${label.toLowerCase()}`}>
          <p className="font-serif text-5xl md:text-7xl leading-none tabular-nums">{pad(value)}</p>
          <p className={`text-[9px] tracking-[0.35em] uppercase mt-3 ${dark ? "text-white/40" : "text-black/40"}`}>
            {label}
          </p>
        </div>
      ))}
    </div>
  );
};
